import { IAction } from "src/store";
import { augmentReducer } from "src/store/utils";
import { getPreviousState } from "src/shared/utils";
import { parentReducerConstants, categoryReducer, searchReducer } from "./redux";
import { CategoryReducerState } from "./types";

const initialMetaState = {
  header: "",
  filters: getPreviousState("category.filters") || {},
  chartsDataPending: false,
};

const parentReducer = (state = initialMetaState, { type, payload }: IAction<symbol, any>) => {
  switch (type) {
    case parentReducerConstants.get("SET_HEADER_L2")!:
      return { ...state, header: payload };
    case parentReducerConstants.get("SET_CATEGORIES_FILTERS"):
      return {
        ...state,
        filters: payload,
      };
    case parentReducerConstants.get("FETCHING_CATEGORY_DATA"):
      return { ...state, chartsDataPending: payload };
    default:
      return state;
  }
};

export default augmentReducer<CategoryReducerState, IAction<symbol, any>>(parentReducer)({
  metrics: categoryReducer,
  search: searchReducer,
});
